var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('circle',{staticStyle:{"z-index":"101"},attrs:{"r":"4","cx":_vm.x,"cy":_vm.y}})}
var staticRenderFns = []

export { render, staticRenderFns }